export default __webpack_public_path__ + "static/media/downArrow.8abbcc91.svg";